import Vue from "vue";
import VueI18n from 'vue-i18n';
import caJs from '@/locales/ca';
import enJs from '@/locales/en';
import esJs from '@/locales/es';

Vue.use(VueI18n);
Vue.locale = () => {};

export const i18n = new VueI18n({
    locale: localStorage.getItem('language') || 'es',
    fallbackLocale: 'es',
    messages: {
        es: esJs,
        en: enJs,
        ca: caJs,
    },
    silentTranslationWarn: true
});

export default {
    data: i18n
};
